import {NgModule} from '@angular/core';
import {IdentifierInputComponent} from './identifier-input.component';
import {FormsModule} from '@angular/forms';
import {Timer} from '../../../utils/timer';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [IdentifierInputComponent],
  imports: [FormsModule, CommonModule],
  exports: [IdentifierInputComponent],
  providers: [Timer]
})
export class IdentifierInputModule {
}
